export default __webpack_public_path__ + "static/media/moving.e7aff6db.jpg";